import React, { Component } from "react"
import { AppState } from "src/store"
import { connect } from "react-redux"
import store from "src/store/store"
import DoublePanel, { sortCaret } from "../../../components/common/DoublePanel/DoublePanel"
import axios from "axios"
import AxiosConfig from "../../../utilities/AxiosConfig"
import MsalAuth from '../../../utilities/msalAuth'
import Loader from "../../../components/common/Loader"
import { CSVLink } from "react-csv"
import IconBuilder from "../../../utilities/iconBuilder/IconBuilder"
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap"
import EmployeeOverview from "../EmployeeOverview/EmployeeOverview"
import EmployeeFilter from "./EmployeeFilter"
import EmployeeDataTypes from "../Types/EmployeeTypes"
import CertReferenceTypes from "../Types/CertReferenceTypes"
import snackBar from "../../../utilities/snackBar/SnackBar"
import UserSettings from "../../../utilities/UserSettings"
import reggie from "../../../utilities/Reggie"
import EmpoyeeKeyFilter from "./EmployeeKeyFilter/EmployeeKeyFilter"
import { shouldAllowAccess } from "src/utilities/helper"
import mutator from "src/utilities/mutator"
import AddEmployee from "./AddEmployee/AddEmployee"
import UserReferenceTypes from "src/store/UserReference/types"
import HealthHeader from "../../../components/vault77/health/HealthHeader"
import HealthRowWarning from "../../../components/vault77/health/HealthRowWarning"
import { ReviewHealthProvider } from "../../../components/vault77/health/ReviewHealthContext"
import { HealthRefreshProvider } from "../../../components/vault77/health/HealthRefreshContext"
import { getEmployeeHealth } from "../../../components/vault77/health/api/health.api"
import { getVault77ErrorMessage } from "../../../components/vault77/core/apiError"
import type { Vault77EmployeeHealth, Vault77HealthReport } from "../../../components/vault77/health/types"
import "./Employees.css"


// import secureSession from "../SecureSession"
// import historySession from "../historySession"

interface EmployeeProps {
    singleDetail?: any
    activeKey?: string
    userReference: UserReferenceTypes
}

type EmployeeTypes = {
    employees: Array<EmployeeDataTypes>
    showAll: boolean
    certReference: CertReferenceTypes
    loading: boolean
    placeholder: string
    input: string
    selection: Array<EmployeeDataTypes>
    sharedDetail: boolean
    addEmployee: boolean
    healthReport: Vault77HealthReport | null
    healthLoading: boolean
    healthError: string | null
    activeHealthIssue: string | null
}

class Employees extends Component<EmployeeProps, EmployeeTypes> {
    doublePanelRef = React.createRef()
    activeKey = "UserAdministration"
    headerType = "HeaderCollapsed"
    viewMode = "EmployeeOverview"
    userSettings: any = null
    employeesCopy: Array<EmployeeDataTypes> = []
    masterCopy: Array<EmployeeDataTypes> = []
    typingTimeout: number | any = 0
    typing = false
    currentFilters: Array<{ key: string, triggers: any }> = []

    // defined as a class property so the function reference is stable across renders
    // an inline function in render() gets a new reference each render, causing DoublePanel to treat it as a new component type and remount ManageDetail
    renderDetailPanel = ({ details, handleClose }: any) => {
        const canViewDetail = shouldAllowAccess("PORTAL:EMPLOYEE-DETAIL-VIEWER") || shouldAllowAccess("MYPORTAL:PTO")
        return (
            // Expose the already-loaded Vault77 health report so the Reviews tab can flag the specific
            // reviews that need work (matched by FieldResponse review id). No-op when no report is loaded.
            // HealthRefreshProvider lets deep mutation sites (pay rate / PII / review approval) re-run the
            // health scan after a fix so the gauges + per-row warnings update live, without a page reload.
            <ReviewHealthProvider report={this.state.healthReport}>
            <HealthRefreshProvider onHealthChanged={this.loadHealth}>
            <div className={"EmployeeDetailPanel"}>
                {canViewDetail && <EmployeeOverview
                    employee={details}
                    closeDetailPanel={handleClose}
                    setActiveKey={this.setActiveKey}
                    activeKey={this.activeKey}
                    setHeaderType={this.setHeaderType}
                    headerType={this.headerType}
                    viewMode={this.viewMode}
                    setViewMode={this.setViewMode}
                    updateList={this.updateList}
                    singleDetail={this.props.singleDetail}
                    doublePanelRef={this.doublePanelRef}
                />}
                {!canViewDetail && <div className="MissingEmployeeDetailPermisions">
                    <span className="material-icons">security</span>
                    <p>You dont have the required roles to view an employee detail</p>
                    <Button variant="secondary" onClick={handleClose}>Ok</Button>
                </div>}
            </div>
            </HealthRefreshProvider>
            </ReviewHealthProvider>
        )
    }
    paginationOptions = {
        showTotal: true,
        sizePerPageList: [
            {
                text: "1000", value: 1000
            },
        ],
    }

    softUpdateTextIds = ["LastName", "FirstName", "EmployeeNumber", "Supervisor", "HomeProfitCenter"]

    state = {
        employees: [],
        showAll: false,
        certReference: { SubCategories: [], categories: [], groups: [] },
        loading: false,
        placeholder: "Search",
        input: "",
        selection: [],
        sharedDetail: false,
        addEmployee: false,
        healthReport: null,
        healthLoading: false,
        healthError: null,
        activeHealthIssue: null
    }

    componentDidMount() {
        let location = window.location.href.split("&")
        if (location.length > 1 && !this.props.singleDetail) {
            let UserId = location[1].split("=")[1]
            this.getSingleEmployee(UserId)
            this.setState({ sharedDetail: true })
        } else if (this.props.singleDetail) {
            this.getSingleEmployee(this.props.singleDetail)
        } else {
            this.getAllEmployees(false)
        }
        if (this.props.activeKey) {
            this.activeKey = this.props.activeKey
        }
        if (!this.props.userReference) {
            this.getUserReference()
        }
        this.userSettings = MsalAuth.UserSettings()
        // Vault77 data-quality scan for the header + per-row warnings. GET /api/vault77/health
        // authorizes ALL THREE Vault77 read permissions server-side (the scan spans pay rates,
        // reviews, and sensitive data), so the client gate mirrors that exactly — it only skips
        // the call that would otherwise be a guaranteed 403.
        const canViewHealth =
            shouldAllowAccess("Vault77.Read.PayRate") &&
            shouldAllowAccess("Vault77.Read.EmployeeReview") &&
            shouldAllowAccess("Vault77.Read.EmployeeSensitiveData")
        if (!this.props.singleDetail && canViewHealth) {
            this.loadHealth()
        }
    }

    loadHealth = () => {
        this.setState({ healthLoading: true, healthError: null })
        getEmployeeHealth()
            .then((report) => this.setState({ healthReport: report, healthLoading: false }, () => {
                // The per-row warning icon is produced by the LastName column formatter reading the
                // healthMap built in render(). react-bootstrap-table-next memoizes cells by their ROW
                // data, so a changed healthReport (external to the row) does NOT re-run the formatter —
                // the icons would stay stale until a full reload. Force the table to remount with the
                // fresh columns so the icons reflect the new report. The gauges (a direct child of this
                // component) already update via setState; this covers the table rows.
                const ref: any = this.doublePanelRef.current
                ref?.refreshTable?.()
            }))
            .catch((err) => this.setState({
                healthError: getVault77ErrorMessage(err, "Unable to load the Vault77 health report."),
                healthLoading: false
            }))
    }

    // From the header dropdown: scroll to the unhealthy employee's row and open their record.
    selectUnhealthyEmployee = (employeeId: number) => {
        const row = this.masterCopy.find((e: any) => String(e.UserId) === String(employeeId))
        this.openEmployeeById(employeeId)
        if (row) {
            // Let the detail panel mount, then bring the (now-highlighted) row into view.
            window.setTimeout(() => {
                const el = document.getElementById("LastName" + row.EmployeeNumber)
                if (el) {
                    this.scrollRowIntoView(el)
                }
            }, 150)
        }
    }

    // Gauge click: narrow the employee list to those with the chosen issue type. Clicking the active
    // gauge again clears the filter. Filters the loaded roster (masterCopy) by the report's matching
    // EmployeeIds; text search composes on top since it reads employeesCopy.
    selectHealthIssueType = (code: string) => {
        if (this.state.activeHealthIssue === code) {
            this.clearHealthFilter()
            return
        }
        const report = this.state.healthReport
        if (!report) return
        const matchingIds = new Set(
            report.Employees
                .filter((e) => e.Issues.some((i) => i.Code === code))
                .map((e) => String(e.EmployeeId))
        )
        const temp = this.masterCopy.filter((e: any) => matchingIds.has(String(e.UserId)))
        this.employeesCopy = temp
        this.setState({ activeHealthIssue: code, employees: temp, input: "" })
        this.closeDoublePanel()
    }

    clearHealthFilter = () => {
        this.employeesCopy = this.masterCopy
        this.setState({ activeHealthIssue: null, employees: this.masterCopy, input: "" })
        this.closeDoublePanel()
    }

    // Scrolls ONLY the table's own scroll container (the splitter pane), never the window.
    // Element.scrollIntoView walks up every scrollable ancestor including the document, which
    // shifted the whole page upward; this finds the nearest vertically-scrollable ancestor and
    // adjusts just its scrollTop so the row is centered within it.
    scrollRowIntoView = (el: HTMLElement) => {
        let parent: HTMLElement | null = el.parentElement
        let scroller: HTMLElement | null = null
        while (parent) {
            const overflowY = window.getComputedStyle(parent).overflowY
            if ((overflowY === "auto" || overflowY === "scroll") && parent.scrollHeight > parent.clientHeight) {
                scroller = parent
                break
            }
            parent = parent.parentElement
        }
        if (!scroller) return
        const elRect = el.getBoundingClientRect()
        const scRect = scroller.getBoundingClientRect()
        const delta = (elRect.top - scRect.top) - (scroller.clientHeight / 2) + (elRect.height / 2)
        scroller.scrollTo({ top: scroller.scrollTop + delta, behavior: "smooth" })
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    getUserReference = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/user/reference", AxiosConfig.configValue())
            .then(res => {
                localStorage.setItem("userReference", JSON.stringify(res.data))
                store.dispatch({ type: "POPULATE_USER_REFERENCE", payload: res.data })
            })
            .catch(err => {
                //console.log(err)
            })
    }

    getAllEmployees = (showAll: boolean) => {
        this.setState({ loading: true, showAll: showAll })
        const doublePanel = document.getElementById("employee-double-panel-wrapper")
        if (doublePanel) {
            doublePanel.style.display = "none"
        }
        // axios.get(`${process.env.REACT_APP_API_URL}/api/user/getUserList/${showAll}`, AxiosConfig.configValue())
        axios.get(`${process.env.REACT_APP_API_URL}/api/user/getSupervisorUserList/${showAll}`, AxiosConfig.configValue())
        // axios.get(`${process.env.REACT_APP_API_URL}/api/employeeReview/GetReviewSupervisorUserListWithDelegation/${showAll}`, AxiosConfig.configValue())
            .then(res => {
                this.setState({ employees: res.data.data, loading: false, sharedDetail: false })
                this.employeesCopy = res.data.data
                this.masterCopy = res.data.data
                const doublePanel = document.getElementById("employee-double-panel-wrapper")
                if (doublePanel) {
                    doublePanel.style.display = "block"
                }
            }).catch(err => {
                //console.log(err)
                snackBar({ text: "Failed to fetch employee list Employees.tsx", type: "error", timeout: 4000 })

            })
    }

    getSingleEmployee = (UserId: string, openDetail: boolean = false) => {
        this.setState({ loading: true })
        const doublePanel = document.getElementById("employee-double-panel-wrapper")
        if (doublePanel) {
            doublePanel.style.display = "none"
        }
        axios.get(process.env.REACT_APP_API_URL + "/api/user/getSingleUser/" + UserId, AxiosConfig.configValue())
            .then(res => {
                this.setState({ employees: res.data.users, sharedDetail: true, loading: false })
                this.employeesCopy = res.data.users
                this.masterCopy = res.data.users
                if (doublePanel) {
                    doublePanel.style.display = "block"
                }
                // When opened from the health banner, expand straight into EmployeeOverview.
                if (openDetail && res.data.users && res.data.users.length > 0) {
                    const ref: any = this.doublePanelRef.current
                    ref?.showDetails(res.data.users[0])
                }
            }).catch(err => {
                //console.log(err)
                snackBar({ text: "Employee not found", type: "error", timeout: 4000 })
            })
    }

    // Opens EmployeeOverview for a given employee id (== Vault77 EmployeeId == HR UserId).
    // Used by the Vault77 health banner. Tries the already-loaded list first (instant); if the
    // employee isn't in the current (supervised/active) list, loads just that one and opens it.
    openEmployeeById = (employeeId: number) => {
        const match = this.masterCopy.find((e: any) => String(e.UserId) === String(employeeId))
        if (match) {
            const doublePanel = document.getElementById("employee-double-panel-wrapper")
            if (doublePanel) {
                doublePanel.style.display = "block"
            }
            const ref: any = this.doublePanelRef.current
            ref?.showDetails(match)
        } else {
            this.getSingleEmployee(String(employeeId), true)
        }
    }

    clearInput = () => {
        this.setState({ input: "", employees: this.employeesCopy })
    }

    closeDoublePanel = () => {
        const closePanel: HTMLElement | null = document.getElementById("employee-overview-close-btn-p") || document.getElementById("employee-overview-close-btn-p-collapsed")
        if (closePanel) {
            closePanel.click()
        }
        // secureSession.cancel()
        // historySession.cancel()
    }

    filterText = (input: string, employees: Array<EmployeeDataTypes>) => {
        let temp = []
        for (let i = 0; i < employees.length; i++) {
            let str = Object.values(employees[i]).join().toLowerCase()
            if (str.includes(input.toLowerCase())) {
                temp.push(employees[i])
            }
        }
        if (temp !== this.state.employees) {
            this.setState({ employees: temp })
        }
    }

    handleTextFilter = (event: { target: { value: string } }) => {
        let input = event.target.value
        const self = this
        this.closeDoublePanel()
        this.setState({ input: input })

        if (self.typingTimeout) {
            clearTimeout(self.typingTimeout);
        }

        self.typing = false

        self.typingTimeout = setTimeout(() => {
            if (self.state.input.length > 0) {
                self.filterText(input, self.employeesCopy)
            } else {
                self.setState({ employees: self.employeesCopy })
            }
        }, 800)
    }

    handleKeyFilter = (searchParams: Array<{ key: string, triggers: any }>) => {
        this.currentFilters = searchParams
        let oldLength = this.employeesCopy.length
        // Key-filter rebuilds the working set from masterCopy, overriding any active gauge filter.
        this.setState({ employees: this.employeesCopy, activeHealthIssue: null })
        this.employeesCopy = this.masterCopy
        if (searchParams.length > 0) {
            let temp: Array<EmployeeDataTypes> = []
            let employees = this.employeesCopy
            let paramCount = searchParams.length
            for (let i = 0; i < employees.length; i++) {
                let matches = 0
                for (let j = 0; j < paramCount; j++) {
                    //@ts-ignore
                    if (searchParams[j].triggers.includes(employees[i][searchParams[j].key])) {
                        matches++
                    }
                }
                if (paramCount === matches) {
                    temp.push(employees[i])
                }
            }
            let newLength = temp.length
            this.employeesCopy = temp
            this.setState({ employees: temp })
            if (newLength !== oldLength) {
                this.closeDoublePanel()
            }
        }
        this.clearInput()
    }

    insertEmployee = (employee: EmployeeDataTypes) => {
        let temp = this.state.employees
        //@ts-ignore
        temp.unshift(employee)
        this.setState({ employees: temp })
    }

    updateList = (employee: EmployeeDataTypes | any) => {
        const employeeList = this.state.employees
        const employeeNumber = employee.EmployeeNumber
        const ids = this.softUpdateTextIds

        for (let i = 0; i < employeeList.length; i++) {
            //@ts-ignore
            if (employeeList[i].EmployeeNumber === employeeNumber) {
                for (let j = 0; j < ids.length; j++) {
                    const key = ids[j]
                    //@ts-ignore
                    if (employeeList[i][key] !== employee[key]) {
                        let elem = document.getElementById(`${key}${employeeNumber}`)
                        if (elem) {
                            elem.innerText = employee[ids[j]]
                        }
                    }
                }
            }
        }

        let elem = document.getElementById("employee-overview-header-expanded-supervisor")
        if (elem) {
            elem.innerText = employee.Supervisor
        }

    }

    selectAll = (rows: Array<EmployeeDataTypes>) => {
        this.setState({ selection: rows })
        this.closeDoublePanel()
    }

    deselectAll = () => {
        this.setState({ selection: [] })
        this.closeDoublePanel()
    }

    selectOne = (row: EmployeeDataTypes) => {
        let temp = this.state.selection
        let found = false
        for (let i = 0; i < temp.length; i++) {
            //@ts-ignore
            if (temp[i].UserId === row.UserId) {
                found = true
            }
        }
        if (!found) {
            //@ts-ignore
            temp.push(row)
            this.setState({ selection: temp })
        }
        this.closeDoublePanel()
    }

    deselectOne = (row: EmployeeDataTypes) => {
        let temp = this.state.selection
        let i = 0
        while (i < temp.length) {
            //@ts-ignore
            if (temp[i].UserId === row.UserId) {
                temp.splice(i, 1)
            } else {
                ++i
            }
        }
        this.setState({ selection: temp })
        this.closeDoublePanel()
    }

    setActiveKey = (key: string) => {
        this.activeKey = key
    }

    setViewMode = (mode: string) => {
        this.viewMode = mode
        if (this.userSettings) {
            this.userSettings.hrViewMode = mode
            UserSettings.update(this.userSettings)
        }
    }

    setHeaderType = (type: string) => {
        this.headerType = type
        if (this.userSettings) {
            this.userSettings.hrHeaderType = type
            UserSettings.update(this.userSettings)
        }
    }

    refreshEmployees = () => {
        this.setState({ input: "", loading: true, activeHealthIssue: null })
        this.getAllEmployees(this.state.showAll)
    }

    toggleActive = () => {
        this.setState({ employees: [], input: "", activeHealthIssue: null })
        this.employeesCopy = []
        this.masterCopy = []
        this.getAllEmployees(!this.state.showAll)
        // this.closeDoublePanel()
        // this.clearInput()
    }

    render() {

        const props = this.props
        const state = this.state
        const employees = state.employees
        const singleDetail = this.props.singleDetail
        const canViewDetail = shouldAllowAccess("PORTAL:EMPLOYEE-DETAIL-VIEWER") || shouldAllowAccess("MYPORTAL:PTO")
        const canAddEmployee = shouldAllowAccess("HR:ADMIN")

        // Per-employee Vault77 health lookup (keyed by id == UserId) for the row warning icon.
        const healthMap = new Map<string, Vault77EmployeeHealth>()
        if (state.healthReport) {
            for (const e of state.healthReport.Employees) {
                healthMap.set(String(e.EmployeeId), e)
            }
        }

        const EmployeesTooltip = (text: string) => (
            <Tooltip id="employees-pin-tooltip">
                {text}
            </Tooltip>
        )

        return (
            <div className="Employees main-content col-sm">
                {!singleDetail && <div>
                    {!state.loading && <div className="EmployeeSearchWrapper" id="employee-search-wrapper">
                        {!state.sharedDetail && <div className="EmployeeSearchWrapperLeft">
                            <EmployeeFilter
                                input={state.input}
                                placeholder={state.placeholder}
                                handleFilter={this.handleTextFilter}
                                clearForm={this.clearInput}
                            />
                            <EmpoyeeKeyFilter
                                search={this.handleKeyFilter}
                                toggleActive={this.toggleActive}
                                closeDetailPanel={this.closeDoublePanel}
                                results={state.employees.length}
                            />
                            {canAddEmployee && <HealthHeader
                                report={state.healthReport}
                                loading={state.healthLoading}
                                error={state.healthError}
                                onRefresh={this.loadHealth}
                                onSelectEmployee={this.selectUnhealthyEmployee}
                                activeIssueCode={state.activeHealthIssue}
                                onSelectIssueType={this.selectHealthIssueType}
                            />}
                        </div>}
                        {state.sharedDetail && <div className="SharedDetailToggleWrapper">
                            <OverlayTrigger trigger={["hover", "focus"]} placement="right" overlay={EmployeesTooltip("Jump to employee list")}>
                                <span className="material-icons" onClick={() => this.getAllEmployees(state.showAll)}>groups</span>
                            </OverlayTrigger>
                        </div>}
                        {state.selection.length > 0 && <div id="employee-table-header-results-counter">
                            <OverlayTrigger trigger={["hover", "focus"]} placement="left" overlay={EmployeesTooltip("Download selection as CSV")}>
                                <CSVLink data={state.selection} filename="Employees.csv"><IconBuilder extension="csv" size={32}></IconBuilder></CSVLink>
                            </OverlayTrigger>
                            <p id="employee-count">{state.selection.length} Selected</p>
                        </div>}
                        <div className="EmployeeSearchWrapperRight">
                            {state.selection.length === 0 && <div id="employee-table-header-results-counter">
                                <OverlayTrigger trigger={["hover", "focus"]} placement="left" overlay={EmployeesTooltip("Download CSV")}>
                                    <CSVLink data={employees} filename="Employees.csv"><IconBuilder extension="csv" size={32}></IconBuilder></CSVLink>
                                </OverlayTrigger>
                                {employees.length > 1 && <p id="employee-count">{employees.length} Results</p>}
                                {employees.length === 1 && <p id="employee-count">{employees.length} Result</p>}
                            </div>}
                            {canAddEmployee && <OverlayTrigger trigger={["hover", "focus"]} placement="left" overlay={EmployeesTooltip("Add a new employee")}>
                                <span className="material-icons" id="add-employee-btn" onClick={() => this.manageState([{ key: "addEmployee" }])} >add</span>
                            </OverlayTrigger>}
                            {!state.sharedDetail && <div className="EmployeeViewTypeToggle">
                                <div id="employee-view-open-wrapper" onClick={() => this.toggleActive()}>
                                    <p>Active</p>
                                    {!state.showAll && <div className="EmployeeViewTypeToggleChecked"></div>}
                                    {state.showAll && <div className="EmployeeViewTypeToggleUnchecked"></div>}
                                </div>
                                <div id="employee-view-all-wrapper" onClick={() => this.toggleActive()}>
                                    <p>All</p>
                                    {state.showAll && <div className="EmployeeViewTypeToggleChecked"></div>}
                                    {!state.showAll && <div className="EmployeeViewTypeToggleUnchecked"></div>}
                                </div>
                            </div>}
                            <OverlayTrigger trigger={["hover", "focus"]} placement="left" overlay={EmployeesTooltip("Refresh Employees")}>
                                <div className="EmployeeRefreshWrapper" id="employee-refresh-wrapper"><span className="material-icons" onClick={() => this.refreshEmployees()}>refresh</span></div>
                            </OverlayTrigger>
                        </div>
                    </div>}
                </div>}
                <div id="employee-double-panel-wrapper" style={{ display: "none" }}>
                    <DoublePanel
                        ref={this.doublePanelRef}
                        manual
                        url=""
                        data={employees}
                        keyField="UserId"
                        // wrapperClassName="test"
                        turnIntoModal={false}
                        paginated={state.showAll}
                        paginationOptions={this.paginationOptions}
                        columns={[
                            {
                                sort: true,
                                sortCaret: sortCaret,
                                text: "Last Name",
                                dataField: "LastName",
                                formatter: (cell: any, employee: EmployeeDataTypes) => {
                                    const health = healthMap.get(String(employee.UserId))
                                    return (
                                        <div className="EmployeeFirstColumn">
                                            {state.showAll && employee.Inactive && <div className="EmployeeInactiveIndicator" id={`employee-inactive-indicator-${employee.UserId}`}></div>}
                                            {state.showAll && !employee.Inactive && <div className="EmployeeActiveIndicator" id={`employee-active-indicator-${employee.UserId}`}></div>}
                                            {/* Amber warning only when the employee has issues; otherwise a fixed-width spacer keeps
                                                the name aligned (no green check). Rendered for every row once the scan has loaded. */}
                                            {state.healthReport && <HealthRowWarning employeeName={`${employee.FirstName} ${employee.LastName}`} issues={health ? health.Issues : []} />}
                                            <div id={"LastName" + employee.EmployeeNumber}>
                                                {employee.LastName}
                                                <div id={`hacky-fix-${employee.UserId}`}></div>
                                            </div>
                                        </div>
                                    )
                                },
                                headerFormatter: (column: any, colIndex: number, components: any) => {
                                    return (
                                        <div className="d-flex align-items-center Employee-Table-Header-Formatter">
                                            {column.text}
                                            {components.sortElement}
                                        </div>
                                    )
                                }
                            },
                            {
                                sort: true,
                                sortCaret: sortCaret,
                                text: "First Name",
                                dataField: "FirstName",
                                formatter: (cell: any, employee: EmployeeDataTypes) => (
                                    <div id={"FirstName" + employee.EmployeeNumber}>
                                        {employee.FirstName}
                                    </div>
                                ),
                                headerFormatter: (column: any, colIndex: number, components: any) => {
                                    return (
                                        <div className="d-flex align-items-center Employee-Table-Header-Formatter">
                                            {column.text}
                                            {components.sortElement}
                                        </div>
                                    )
                                }
                            },
                            {
                                sort: true,
                                sortCaret: sortCaret,
                                text: "Employee #",
                                dataField: "EmployeeNumber",
                                formatter: (cell: any, employee: EmployeeDataTypes) => (
                                    <div id={"EmployeeNumber" + employee.EmployeeNumber}>
                                        {employee.EmployeeNumber}
                                    </div>
                                ),
                                headerFormatter: (column: any, colIndex: number, components: any) => {
                                    return (
                                        <div className="d-flex align-items-center Employee-Table-Header-Formatter">
                                            {column.text}
                                            {components.sortElement}
                                        </div>
                                    )
                                }
                            },
                            {
                                sort: true,
                                sortCaret: sortCaret,
                                text: "Supervisor",
                                dataField: "Supervisor",
                                formatter: (cell: any, employee: EmployeeDataTypes) => (
                                    <div id={"Supervisor" + employee.EmployeeNumber}>
                                        {employee.Supervisor}
                                    </div>
                                ),
                                headerFormatter: (column: any, colIndex: number, components: any) => {
                                    return (
                                        <div className="d-flex align-items-center Employee-Table-Header-Formatter">
                                            {column.text}
                                            {components.sortElement}
                                        </div>
                                    )
                                }
                            },
                            {
                                sort: true,
                                sortCaret: sortCaret,
                                text: "Profit Center",
                                dataField: "HomeProfitCenter",
                                formatter: (cell: any, employee: EmployeeDataTypes) => (
                                    <div id={"HomeProfitCenter" + employee.EmployeeNumber}>
                                        {employee.HomeProfitCenter}
                                    </div>
                                ),
                                headerFormatter: (column: any, colIndex: number, components: any) => {
                                    return (
                                        <div className="d-flex align-items-center Employee-Table-Header-Formatter">
                                            {column.text}
                                            {components.sortElement}
                                        </div>
                                    )
                                }
                            },
                            {
                                sort: true,
                                sortCaret: sortCaret,
                                text: "Work Phone",
                                dataField: "WorkPhone",
                                formatter: (cell: any, employee: EmployeeDataTypes) => (
                                    <div id={"WorkPhone" + employee.EmployeeNumber}>
                                        <a id={"employee-work-phone-link-" + employee.EmployeeNumber} onClick={e => e.stopPropagation()} href={`tel:${reggie.formatPhone(employee.WorkPhone || "")}`}>{reggie.formatPhone(employee.WorkPhone || "")}</a>
                                        {/* {employee.WorkPhone} */}
                                    </div>
                                ),
                                headerFormatter: (column: any, colIndex: number, components: any) => {
                                    return (
                                        <div className="d-flex align-items-center Employee-Table-Header-Formatter">
                                            {column.text}
                                            {components.sortElement}
                                        </div>
                                    )
                                }
                            },
                            {
                                sort: true,
                                sortCaret: sortCaret,
                                text: "Work Email",
                                dataField: "WorkEmail",
                                formatter: (cell: any, employee: EmployeeDataTypes) => (
                                    //@ts-ignore
                                    <div id={"WorkEmail" + employee.EmployeeNumber}>
                                        <a id={"employee-work-email-link-" + employee.EmployeeNumber} onClick={e => e.stopPropagation()} href={`mailto:${employee.WorkEmail}`}>{employee.WorkEmail}</a>
                                        {/* {employee.WorkEmail} */}
                                    </div>
                                ),
                                headerFormatter: (column: any, colIndex: number, components: any) => {
                                    return (
                                        <div className="d-flex align-items-center Employee-Table-Header-Formatter">
                                            {column.text}
                                            {components.sortElement}
                                        </div>
                                    )
                                }
                            },
                        ]}
                        tableProps={{
                            selectRow: {
                                mode: "checkbox",
                                // selected: selected.map(item => item[keyField]),
                                bgColor: "#C4C5C6",
                                onSelect: (row: EmployeeDataTypes, isSelected: boolean) => {
                                    if (isSelected) {
                                        this.selectOne(row)
                                    } else {
                                        this.deselectOne(row)
                                    }
                                },
                                onSelectAll: (isSelected: boolean, rows: Array<EmployeeDataTypes>) => {
                                    if (isSelected) {
                                        this.selectAll(rows)
                                    } else {
                                        this.deselectAll()
                                    }
                                },
                                selectionRenderer: ({ mode, ...rest }: any) => {
                                    const p: any = (({ rowIndex, rowKey, ...r }) => r)(rest)
                                    return (
                                        <input className="table-select-checkbox" type={mode} {...p} readOnly />
                                    )
                                }
                            }
                        }}
                        DetailPanel={this.renderDetailPanel}
                    />
                </div>
                {state.addEmployee && <AddEmployee
                    manageParentState={this.manageState}
                    insertEmployee={this.insertEmployee}
                    employees={this.employeesCopy}
                />}
                {state.loading && !singleDetail && <div className="LoadingEmployees">
                    <span className="material-icons">groups</span>
                    <Loader title="Loading" />
                </div>}
                {state.loading && singleDetail && <div className="LoadingEmployees">
                    <span className="material-icons">person</span>
                    <Loader title="Loading" />
                </div>}
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userReference: state.userReference.userReference
})

export default connect(mapStateToProps)(Employees)